<template>
    <div style="display: flex; justify-content: center;">
        <main class="main-content-dealer-app">
            <div class="content-wrapper-dealer-app">
                
                <section class="main-section-dealer-app">
                    <div id="errorMessage" v-if="form.errors.message ? form.errors.message : form.errors.error" class="notification notification-error">
                        <p class="paragraph-details"><strong>Error Notification</strong> {{ form.errors.message ? form.errors.message : form.errors.error }}</p>
                    </div>
                    <div v-if="message.type" :class="
                    {
                        'notification': true,
                        'notification-success': message.type == 'success',
                    }">
                        <p class="paragraph-details">{{ message.message }}</p>
                    </div>
                    <DealerTypeDealerApplication 
                        v-model:existingDealerOption="existingDealerOption"
                        v-model:rothco_dealer_no="form.rothco_dealer_no"
                        v-model:zip="form.zip"
                        v-model:errors="form.errors"
                        v-model:email_address="form.email_address"
                        v-model:password="form.password"
                        v-model:password_confirmation="form.password_confirmation"
                        :isLoggedIn="isLoggedIn"
                    />
                    <CompanyDealerApplication
                        v-if="!existingDealerOption"
                        v-model:company_name="form.company_name"
                        v-model:country="form.country"
                        v-model:dealer_type="form.dealer_type"
                        v-model:customer_resales_types="form.customer_resales_types"
                        v-model:federal_tax_id_or_state_license="form.federal_tax_id_or_state_license"
                        v-model:asi="form.asi"
                        v-model:in_care_of="form.in_care_of"
                        v-model:mailing_address_1="form.mailing_address_1"
                        v-model:mailing_address_2="form.mailing_address_2"
                        v-model:city="form.city"
                        v-model:state_province="form.state_province"
                        v-model:zip_postal_code="form.zip_postal_code"
                        v-model:location_type="form.location_type"
                        v-model:customer_business_description="form.customer_business_description"
                        v-model:errors="form.errors"
                        :countries="props.countries"
                        :states="props.states"
                        :resaleTypes="props.resaleTypes"
                        :primaryResaleTypes="props.primaryResaleTypes"
                    />

                    <ContactDealerApplication 
                        v-if="!existingDealerOption"
                        v-model:email_address="form.email_address"
                        v-model:password="form.password"
                        v-model:password_confirmation="form.password_confirmation"
                        v-model:primary_contact="form.primary_contact"
                        v-model:primary_contact_title="form.primary_contact_title"
                        v-model:business_phone_number="form.business_phone_number"
                        v-model:mobile_phone_number="form.mobile_phone_number"
                        v-model:additional_contacts="form.additional_contacts"
                        v-model:errors="form.errors"
                    />

                    <AdditionalInfoDealerApplication 
                        v-if="!existingDealerOption"
                        v-model:customer_date_founded="form.customer_date_founded"
                        v-model:customer_employees="form.customer_employees"
                        v-model:how_did_you_hear_about_rothco="form.how_did_you_hear_about_rothco"
                        v-model:how_did_you_hear_about_rothco_details="form.how_did_you_hear_about_rothco_details"
                        v-model:total_annual_sale="form.total_annual_sale"
                        v-model:total_outside_sale="form.total_outside_sale"
                        v-model:total_stores="form.total_stores"
                        v-model:number_of_gov_contracts="form.number_of_gov_contracts"
                        v-model:gov_websites="form.gov_websites"
                        v-model:customer_business_federal="form.customer_business_federal"
                        v-model:customer_business_state="form.customer_business_state"
                        v-model:customer_business_local="form.customer_business_local"
                        v-model:customer_business_private="form.customer_business_private"
                        v-model:company_socials="form.company_socials"
                        v-model:urls_featuring_rothco="form.urls_featuring_rothco"
                        v-model:top_vendor_1="form.top_vendor_1"
                        v-model:top_vendor_2="form.top_vendor_2"
                        v-model:top_vendor_3="form.top_vendor_3"
                        v-model:sale_on_other_countries="form.sale_on_other_countries"
                        v-model:describe_end_user="form.describe_end_user"
                        v-model:screenprint_embroider_logo="form.screenprint_embroider_logo"
                        v-model:dealer_type="form.dealer_type"
                        v-model:errors="form.errors"
                        :countries="props.countries"
                        :hideSource="props.hideSource"
                        :conditionalSalesperson="props.conditionalSalesperson"
                        v-model:conditional_salesperson="form.conditional_salesperson"
                        :socialOptions="props.digitalProfileTypes"
                    />

                    <ShippingInfoDealerApplication 
                        v-if="!existingDealerOption"
                        v-model:shipping_in_care_of="form.shipping_in_care_of"
                        v-model:shipping_address1="form.shipping_address1"
                        v-model:shipping_address2="form.shipping_address2"
                        v-model:shipping_city="form.shipping_city"
                        v-model:shipping_country="form.shipping_country"
                        v-model:shipping_state="form.shipping_state"
                        v-model:shipping_zip_code="form.shipping_zip_code"
                        v-model:additional_shippings="form.additional_shippings"
                        v-model:errors="form.errors"
                        v-model:sameAsMailingAddress="sameAsMailingAddress"
                        :regions="props.states"
                        :countries="props.countries"
                    />

                    <RetailDealerApplication 
                        v-if="!existingDealerOption"
                        v-model:retail_in_care_of="form.retail_in_care_of"
                        v-model:retail_address1="form.retail_address1"
                        v-model:retail_address2="form.retail_address2"
                        v-model:retail_city="form.retail_city"
                        v-model:retail_country="form.retail_country"
                        v-model:retail_state="form.retail_state"
                        v-model:retail_zip_code="form.retail_zip_code"
                        v-model:dealer_type="form.dealer_type"
                        v-model:errors="form.errors"
                        v-model:retailOption="retailOption"
                        :regions="props.states"
                        :countries="props.countries"
                    />

                    <div v-if="!existingDealerOption">
                    <h2 class="headline-s form-headline-dealer-app">Resale Certificate</h2>
                    <p class="form-headline-dealer-app">(Companies based in the USA must upload a valid resale certificate for all ship to states to be approved as a Rothco dealer)</p>
                    <div class="field-type-dealer-app">
                        <div class="field-state-dealer-app input-folder">
                            <div class="input-folder--input">
                                <input 
                                    id="resale_certificate_file"
                                    @change="setFile"
                                    type="file"
                                    :class="{'invalid-state-input': form.errors.resale_certificate != null}"
                                    placeholder=" "
                                    ref="resaleCeritificateFileInput"
                                    fluid
                                />
                                <input @click="triggerResaleFileClick" type="text" style="cursor: pointer;" readonly :value="getFileName(form.resale_certificate)" />
                                <label for="resale_certificate_file" :class="{'invalid-state': form.errors.resale_certificate}">
                                    <p>Choose File</p>
                                </label>
                            </div>
                            <div class="input-folder--support">
                                <p class="input-support-text invalid-state">{{ form.errors.resale_certificate }}</p>
                            </div>
                        </div>
                        <div class="field-state-dealer-app input-folder">
                            <div class="input-folder--input">
                                <InputText 
                                    id="resale_certificate_number" v-model="form.resale_certificate_no"
                                    :class="form.errors.resale_certificate_no != null ? 'invalid-state-input' : ''"
                                    placeholder=" "
                                    fluid
                                />
                                <label for="resale_certificate_number" :class="{'invalid-state': form.errors.resale_certificate_no}">
                                    <p>Resale Certificate No.</p>
                                </label>
                            </div>
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.resale_certificate_no">{{ form.errors.resale_certificate_no }}</p></div>
                        </div>
                    </div>
                    <div class="field-state-dealer-app">
                        <div class="textarea-folder">
                            <textarea id="comments" v-model="form.comments" placeholder=" "></textarea>
                            <label class="paragraph-default" for="comments">Comments</label>
                        </div>
                    </div>
                    </div>
                    <div class="reseller-agreement">
                        <div style="display: flex; flex-direction: column;">
                            <div class="links-and-input">
                                <input type="checkbox" id="reseller_agreement" name="reseller_agreement" aria-label="Accept Reseller Agreement" v-model="reseller_agreement">
                                <a target="_blank" :href="route('index.resellerAgreement')">I Accept Rothco's Reseller Agreement</a> <a target="_blank" :href="route('index.resellerAgreement', ['es'])">(En Español)</a>
                            </div>
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.terms_condition">{{ form.errors.terms_condition }}</p></div>
                        </div>
                    </div>
                    <div class="dealer-app-footer">
                        <Recaptcha ref="recaptcha" v-model="captchaResponse" theme="light" />
                    </div>
                    <div class="dealer-app-footer" >
                        <RothcoCta class="primary" id="submit_form" @click="submitForm" :disabled="form.processing">Submit</RothcoCta>
                    </div>
                    <p class="form-headline-dealer-app">
                        If you are experiencing issues completing this form please email <a a href="mailto:DealerAcctSetup@Rothco.com?subject=Dealer%20Application" target="_blank">DealerAcctSetup@Rothco.com</a>
                    </p>
                    <p class="form-headline-dealer-app">
                        Rothco is not accepting applications for products to be sold on a digital marketplace, such as Amazon or eBay. All companies that wish to sell Rothco product online must have a fully functional ecommerce website that has been active for more than one year.
                    </p>
                </section>
            </div>
        </main>
    </div>
</template>
<script lang="ts" setup>
    import { computed, ref, watch, nextTick, onMounted, inject} from "vue";
    import { useForm, getFirstInvalidInputElement } from "@/helpers/composables/useForm";
    import { string, object, array, mixed} from 'yup';
    import { storeToRefs } from "pinia";
    import { usePage } from '@inertiajs/vue3';
    import { useSettingsStore } from "@/store/settings";
    import RothcoCta from "@/components/RothcoCta.vue";
    import Recaptcha from "@/components/Recaptcha.vue";
    import InputText from "primevue/inputtext";
    import DealerTypeDealerApplication from "@/components/DealerTypeDealerApplication.vue";
    import CompanyDealerApplication from "@/components/CompanyDealerApplication.vue";
    import ContactDealerApplication from "@/components/ContactDealerApplication.vue";
    import AdditionalInfoDealerApplication from "@/components/AdditionalInfoDealerApplication.vue";
    import ShippingInfoDealerApplication from "@/components/ShippingInfoDealerApplication.vue";
    import RetailDealerApplication from "@/components/RetailDealerApplication.vue";
    import { useFetch } from "@/helpers/composables/useFetch";
    import { watchDebounced } from "@vueuse/core";
    import { validateEmail } from "@/utils/validateEmail";
    let route = inject('route');
    let store = useSettingsStore();
    let { isLoggedIn } = storeToRefs(store);

    let message = computed(() => {
        return usePage()?.props?.flash?.message ?? {
            type: null
        };
    })

    let props = defineProps({
        countries: {
            type: Object,
            default(){
                return {};
            }
        },
        states: {
            type: String,
            default: ''
        },
        hideSource: {
            type: Boolean,
            default: false
        },
        conditionalSalesperson: {
            type: Boolean,
            default: false
        },
        bypassRecaptcha: {
            type: Boolean,
            default: false
        },
        digitalProfileTypes: {
            type: Array,
            default: []
        },
        resaleTypes: {
            type: Array<Object>,
            default: []
        },
        primaryResaleTypes: {
            type: Array<Object>,
            default: []
        },
    });

    function phoneCheck (phoneNumber) {
        phoneNumber = phoneNumber?.replace?.(/\D/g, "") ?? "";
        return phoneNumber?.length == 10;
    };

    let abortEarly = ref(true);
    

    let sameAsMailingAddress = ref(true);
    let retailOption = ref('add');


    let existingDealerOption = ref(usePage().props.existing == 1);

    let form = useForm({
        useInertia: true,
        // inertiaAlias: "DealerApplication",
        abortEarly,
        schema: object({
            // existing dealer form
            rothco_dealer_no: string().optional().test(
                'is-not-empty',
                'Existing dealer number is required',
                (value) => {
                    if(existingDealerOption.value == true){
                        if(abortEarly.value && !fieldsChanged.value.rothco_dealer_no){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            zip: string().optional().test(
                'is-not-empty',
                'Postal Code is required',
                (value) => {
                    if(existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.zip){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            // company form
            company_name: string().optional().test(
                'is-not-empty',
                'Company name is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.company_name){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            country: string().optional().test(
                'is-not-empty',
                'Country is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.country){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default('US'),
            dealer_type: string().optional().test(
                'is-not-empty',
                'Dealer type is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.dealer_type){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            customer_resales_types: array().of(string().optional().default('')).default([]),
            federal_tax_id_or_state_license: string().optional().test(
                'is-not-empty',
                'Federal Tax ID or State License is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.federal_tax_id_or_state_license){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            asi: string().optional().default(''),
            in_care_of: string().optional().default(''),
            mailing_address_1: string().optional().test(
                'is-not-empty',
                'Mailing address is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.mailing_address_1){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            mailing_address_2: string().optional().default(''),
            city: string().optional().test(
                'is-not-empty',
                'City is required',
                (value) => {
                    if(!existingDealerOption.value && (form.country == 'US' || form.country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.city){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            state_province: string().optional().test(
                'is-not-empty',
                'State/Province is required',
                (value) => {
                    if(!existingDealerOption.value && (form.country == 'US' || form.country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.state_province){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            zip_postal_code: string().optional().test(
                'is-not-empty',
                'Zip/Postal code is required',
                (value) => {
                    if(!existingDealerOption.value && (form.country == 'US' || form.country =='CA')){
                        if(abortEarly.value && !fieldsChanged.value.zip_postal_code){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            location_type: string().optional().test(
                'is-not-empty',
                'Location type is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.location_type){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            customer_business_description: string().optional().test(
                'is-not-empty',
                'Customer business description is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.customer_business_description){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),

            // contact information
            email_address: string().email().optional().test({
                name: "email_address",
                message: "Please use a valid email address (example: yourname@yoursite.com)",
                test: (value) => {
                    if(!existingDealerOption.value || (existingDealerOption.value && !isLoggedIn.value)){
                        if(abortEarly.value && !fieldsChanged.value.email_address){
                        return value === undefined || value === '' || validateEmail(value);
                        }
                        return validateEmail(value);
                    }
                    return true;
                }
                }).default(''),
            password_confirmation: string().optional().test(
                'is-not-empty',
                'The confirm password field is required',
                (value) => {
                    return (value) || (existingDealerOption.value && isLoggedIn.value);
                }
                ).test({
                name: "password_confirmation",
                message: "Password confirmation does not match",
                test: (value) => {
                    return (value == form.password) || (existingDealerOption.value && isLoggedIn.value);
                }
                }).default(''),
            password: string()
                .when([],{
                    is: ()=>(existingDealerOption.value && isLoggedIn.value),
                    then: pword => pword.optional(),
                    otherwise: pword => pword.required('The password field is required'),
                })
                .test('password-strength', '', (value, ctx) => {
                    if(existingDealerOption.value && isLoggedIn.value){
                        return true;
                    }
                    if (!value) return true;
                    let messages = [];
                    let weakPasswordMessage;
                    if (!/[A-Z]/.test(value)) messages.push('at least one uppercase letter');
                    if (!/[a-z]/.test(value)) messages.push('at least one lowercase letter');
                    if (!/[0-9]/.test(value)) messages.push('at least one number');
                    if (!/[#?!@$%^&*-]/.test(value)) messages.push('at least one special character (# ? ! @ $  % ^ & * -)');
                    if (/\s/.test(value)) messages.push('no spaces');
                    if (value.length < 8) messages.push('at least 8 characters');
                    if (/password/i.test(value)) weakPasswordMessage = 'Your password is too weak.';
                    if (messages.length || weakPasswordMessage) return ctx.createError({ message: messages.length > 0 ? `Password must contain ${messages.join(', ')}.${weakPasswordMessage ? " " + weakPasswordMessage : ""}` : weakPasswordMessage });
                    return true;
                })
                .default(""),
            primary_contact: string().optional().test(
                'is-not-empty',
                'Primary contact is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.primary_contact){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            primary_contact_title: string().optional().test(
                'is-not-empty',
                'Primary contact title is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.primary_contact_title){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            business_phone_number: string().optional().test(
                'is-not-empty',
                'Business phone number is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.business_phone_number){
                            return value === undefined || value === '' || value?.match?.(/\d/g)?.length === 10
                        }
                        return  value !== undefined || value !== '' || value?.match?.(/\d/g)?.length === 10
                    }
                    return true;
                }
                ).default(''),
            mobile_phone_number: string().optional().default(''),
            additional_contacts: array().of(
                    object({
                        phone: string().default(''),
                        email: string().required('Email is required'),
                        title: string().required('Title is required'),
                        name: string().required('Name is required'),
                    })
                ).optional().default([]),

            // Additional Information
            customer_date_founded: mixed().optional().test(
                'is-not-empty',
                'Company date founded is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if (abortEarly.value && !fieldsChanged.value.customer_date_founded) {
                            return value === undefined || value === '' || value !== null;
                        }
                        return value !== undefined && value !== '' && value !== null;
                    }
                    return true;
                }
            ).test(
                'is-valid-date',
                'Company date founded cannot be in the future',
                (value) => {
                    if (value && !existingDealerOption.value) {
                        const today = new Date();
                        const foundedDate = new Date(value);
                        return foundedDate <= today;
                    }
                    return true;
                }
            ).default(''),
            customer_employees: string().optional().test(
                'is-not-empty',
                'Please enter your total employees',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.customer_employees){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            how_did_you_hear_about_rothco: string().optional().test(
                'is-not-empty',
                'How did you hear about Rothco?',
                (value) => {
                if(!props.hideSource && !existingDealerOption.value){
                    if(abortEarly.value && !fieldsChanged.value.how_did_you_hear_about_rothco){
                        return value === undefined || value === '' || value !== null
                    }
                    return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            how_did_you_hear_about_rothco_details: string().optional().test(
                'is-not-empty',
                'Please specify how you heard about Rothco',
                (value) => {
                if(!props.hideSource && ['trade_organization', 'trade_show', 'social'].includes(form.how_did_you_hear_about_rothco) && !existingDealerOption.value){
                    if(abortEarly.value && !fieldsChanged.value.how_did_you_hear_about_rothco_details){
                        return value === undefined || value === '' || value !== null
                    }
                    return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            total_annual_sale: string().optional().test(
                'is-not-empty',
                'Total annual sales is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.total_annual_sale){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true
                }
                ).default(''),
            total_outside_sale: string().optional().test(
                'is-not-empty',
                'Total outside sales is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.total_outside_sale){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            total_stores: string().optional().test(
                'is-not-empty',
                'Total number of stores is required',
                (value) => {
                    if(form.dealer_type == 'brick_mortar' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.total_stores){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            number_of_gov_contracts: string().optional().test(
                'is-not-empty',
                'Number of Government contracts is required',
                (value) => {
                    if(form.dealer_type == 'government' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.number_of_gov_contracts){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            gov_websites: string().optional().default(''),        
            customer_business_federal: string().optional().test(
                'is-not-empty',
                'Please list the percentage of business done on a federal level',
                (value) => {
                    if(form.dealer_type == 'government' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.customer_business_federal){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            customer_business_state: string().optional().test(
                'is-not-empty',
                'Please list the percentage of business done on a state level',
                (value) => {
                    if(form.dealer_type == 'government' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.customer_business_state){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''), 
            customer_business_local: string().optional().test(
                'is-not-empty',
                'Please list the percentage of business done on a local level',
                (value) => {
                    if(form.dealer_type == 'government' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.customer_business_local){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            customer_business_private: string().optional().test(
                'is-not-empty',
                'Please list the percentage of business done on a private level',
                (value) => {
                    if(form.dealer_type == 'government' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.customer_business_private){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
                company_socials: array().of(
                    object({
                        url: string()
                            .test(
                                'is-valid-url',
                                'Enter a valid URL.',
                                (value, context) => {
                                    if (context.parent.digital_profile_type === 'Web') {
                                        return /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/.test(value || '');
                                    }
                                    return true;
                                }
                            )
                            .required('URL / Handle is required'),
                        digital_profile_type: string().required('Digital profile type is required')
                    })
                ).optional().default([]),
            urls_featuring_rothco: string().optional().default(''),
            top_vendor_1: string().optional().default(''),
            top_vendor_2: string().optional().default(''),
            top_vendor_3: string().optional().default(''),
            sale_on_other_countries: array().of(string().optional().default('')).test(
                'is-not-empty',
                'Please Enter Outside Countries Sold To',
                (value) => {
                    if (!existingDealerOption.value) {
                        if (form.total_outside_sale !== 'customer_export_sales_0_perc') {
                            if (abortEarly.value && !fieldsChanged.value.sale_on_other_countries) {
                                return true;
                            }
                            return Array.isArray(value) && value.length > 0 && value.some((v) => v.trim() !== '');
                        }
                    }
                    return true;
                }
            ).default([]),

            describe_end_user: string().optional().test(
                'is-not-empty',
                'End user description is required',
                (value) => {
                    if(!existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.describe_end_user){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true
                }
                ).default(''),
            screenprint_embroider_logo: string().optional().test(
                'is-not-empty',
                'Do you screen print, embroider or logo the products you sell?',
                (value) => {
                    if(form.dealer_type == 'promotional' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.screenprint_embroider_logo){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),

            // shipping information
            shipping_in_care_of: string().optional().test(
                'is-not-empty',
                'In Care Of is required',
                (value) => {
                        if(!sameAsMailingAddress.value && !existingDealerOption.value){
                            if(abortEarly.value && !fieldsChanged.value.shipping_in_care_of){
                                return value === undefined || value === '' || value !== null
                            }
                            return  value !== undefined && value !== '' && value !== null
                        }
                        return true;
                    }
                ).default(''),
            shipping_address1: string().optional().test(
                'is-not-empty',
                'Street 1 is required',
                (value) => {
                    if(!sameAsMailingAddress.value && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.shipping_address1){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            shipping_address2: string().optional().default(''),
            shipping_city: string().optional().test(
                'is-not-empty',
                'City is required',
                (value) => {
                    if(!sameAsMailingAddress.value && !existingDealerOption.value && (form.shipping_country == 'US' || form.shipping_country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.shipping_city){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            shipping_country: string().optional().test(
                'is-not-empty',
                'Country is required',
                (value) => {
                    if(!sameAsMailingAddress.value && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.shipping_country){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default('US'),
            shipping_state: string().optional().test(
                'is-not-empty',
                'State is required',
                (value) => {
                    if(!sameAsMailingAddress.value && !existingDealerOption.value && (form.shipping_country == 'US' || form.shipping_country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.shipping_state){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            shipping_zip_code: string().optional().test(
                'is-not-empty',
                'Postal Code is required',
                (value) => {
                    if(!sameAsMailingAddress.value && !existingDealerOption.value && (form.shipping_country == 'US' || form.shipping_country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.shipping_zip_code){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),


            additional_shippings: array().of(
                    object({
                        zip_code: string().optional().test(
                            'is-not-empty',
                            'Postal Code is required',
                            (value, context) => {
                                if(context.parent.country == 'US' || context.parent.country == 'CA'){
                                    return value !== undefined && value !== '' && value !== null;
                                }
                                return true;
                            }
                        ),
                        state: string().optional().test(
                            'is-not-empty',
                            'State is required',
                            (value, context) => {
                                if(context.parent.country == 'US' || context.parent.country == 'CA'){
                                    return  value !== undefined && value !== '' && value !== null;
                                }
                                return true;
                            }
                        ).default(''),
                        country: string().required('Country is required').default(''),
                        city: string().optional().test(
                            'is-not-empty',
                            'City is required',
                            (value, context) => {
                                if(context.parent.country == 'US' || context.parent.country == 'CA'){
                                    return  value !== undefined && value !== '' && value !== null;
                                }
                                return true;
                            }
                        ),
                        address2: string().optional(),
                        address1: string().required('Address 1 is required'),
                        in_care_of: string().required('In Care Of is required'),
                    })
                ).optional().default([]),

            // retail info

            retail_in_care_of: string().optional().test(
                'is-not-empty',
                'In Care Of is required',
                (value) => {
                    if(retailOption.value == 'add' && form.dealer_type == 'brick_mortar' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.retail_in_care_of){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            retail_address1: string().optional().test(
                'is-not-empty',
                'Street 1 is required',
                (value) => {
                    if(retailOption.value == 'add' && form.dealer_type == 'brick_mortar' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.retail_address1){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            retail_address2: string().optional().default(''),
            retail_city: string().optional().test(
                'is-not-empty',
                'City is required',
                (value) => {
                    if(retailOption.value == 'add' && form.dealer_type == 'brick_mortar' && !existingDealerOption.value && (form.retail_country == 'US' || form.retail_country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.retail_city){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            retail_country: string().optional().test(
                'is-not-empty',
                'Country is required',
                (value) => {
                    if(retailOption.value == 'add' && form.dealer_type == 'brick_mortar' && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.retail_country){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default('US'),
            retail_state: string().optional().test(
                'is-not-empty',
                'State is required',
                (value) => {
                    if(retailOption.value == 'add' && form.dealer_type == 'brick_mortar' && !existingDealerOption.value && (form.retail_country == 'US' || form.retail_country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.retail_state){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            retail_zip_code: string().optional().test(
                'is-not-empty',
                'Postal Code is required',
                (value) => {
                    if(retailOption.value == 'add' && form.dealer_type == 'brick_mortar' && !existingDealerOption.value && (form.retail_country == 'US' || form.retail_country == 'CA')){
                        if(abortEarly.value && !fieldsChanged.value.retail_zip_code){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
            resale_certificate: mixed().optional().test(
                'file-size',
                'File size must be less than 2 MB',
                (value) => {
                    if(value && !existingDealerOption.value){
                        let file = new File([value], value.name, { type: value.type });
                        if (file && file.size) {
                            return value.size <= 2 * 1024 * 1024; // 2 MB in bytes
                        }
                    }   

                    return true;
                }
            ).test(
                'file-type',
                'File must be of type jpeg, jpg, png, pdf, doc, docx, or odt',
                (value) => {
                    if (value && value.type && !existingDealerOption.value) {
                        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text'];
                        return allowedTypes.includes(value.type);
                    }
                    return true;
                }
            ),
            resale_certificate_no: string().optional().default(''),
            comments: string().optional().default(''),
            terms_condition: string().optional().test(
                'is-not-empty',
                'You must accept the terms and conditions',
                (value) => {
                    if(abortEarly.value && !fieldsChanged.value.terms_condition){
                        return value === undefined || value === '' || value !== null
                    }
                    return  value !== undefined && value !== '' && value !== null
                }
                ).default(''),
            conditional_salesperson: string().optional().test(
                'is-not-empty',
                'Salesperson is required',
                (value) => {
                    if(props.conditionalSalesperson && !existingDealerOption.value){
                        if(abortEarly.value && !fieldsChanged.value.conditional_salesperson){
                            return value === undefined || value === '' || value !== null
                        }
                        return  value !== undefined && value !== '' && value !== null
                    }
                    return true;
                }
                ).default(''),
        }),
    });

    let captchaResponse = ref();
    let recaptcha = ref();

    let recaptchaValid = computed(()=>{
        return captchaResponse.value != null && captchaResponse.value != '';
    });

    let hasTypedInField = ref(new Map());
    watch(() =>form.password, (value) => {
        if(value?.length > 0) {
            hasTypedInField.value.set('password', true);
        }
    })
    let fields = [
        'rothco_dealer_no',  
        'zip',      
        'company_name',
        'country',
        'dealer_type',
        'federal_tax_id_or_state_license',
        'asi',
        'in_care_of',
        'mailing_address_1',
        'mailing_address_2',
        'city',
        'state_province',
        'zip_postal_code',
        'location_type',
        'customer_business_description',
        'email_address',
        'password',
        'password_confirmation',
        'primary_contact',
        'primary_contact_title',
        'business_phone_number',
        'mobile_phone_number',
        'customer_date_founded',
        'customer_employees',
        'how_did_you_hear_about_rothco',
        'how_did_you_hear_about_rothco_details',
        'total_annual_sale',
        'total_outside_sale',
        'total_stores',
        'number_of_gov_contracts',
        'gov_websites',
        'customer_business_federal',
        'customer_business_state',
        'customer_business_local',
        'customer_business_private',
        'top_vendor_1',
        'sale_on_other_countries',
        'describe_end_user',
        'screenprint_embroider_logo',
        'shipping_in_care_of',
        'shipping_address1',
        'shipping_city',
        'shipping_country',
        'shipping_state',
        'shipping_zip_code',
        'retail_in_care_of',
        'retail_address1',
        'retail_city',
        'retail_country',
        'retail_state',
        'retail_zip_code',
        'resale_certificate',
        'resale_certificate_no',
        'terms_condition',
        'company_socials',
        'additional_contacts',
        'additional_shippings',
        'conditional_salesperson'
    ]
    let fieldsChanged = ref(fields.reduce((acc, field) => {
        acc[field] = false;
        return acc;
    }, {}));

    for(let field of fields){
        watch(() => form[field], (newVal)=>{
            if(newVal !== ''){
                fieldsChanged.value[field] = true;
            }
        }, {deep: true});
    }

    let reseller_agreement = ref(false);

    watch(reseller_agreement, (newVal)=>{
        if(newVal){
            form.terms_condition = '1';
        }else{
            form.terms_condition = '';
        }
    });

    watch([existingDealerOption, sameAsMailingAddress, retailOption], ([newExistingDealerOption], [oldExistingDealerOption])=>{
        if(newExistingDealerOption != oldExistingDealerOption && !isLoggedIn.value){
            form.email_address = '';
            form.password = '';
            form.password_confirmation = '';
            form.company_socials = [];
            form.additional_contacts = [];
            form.additional_shippings = [];
        }else if(newExistingDealerOption != oldExistingDealerOption){
            form.company_socials = [];
            form.additional_contacts = [];
            form.additional_shippings = [];
        }
        form.validate({all: true});
    });

    let canSubmitForm = computed(()=>!Object.keys(form.errors)?.length && recaptchaValid.value && reseller_agreement.value);
    let submitForm = async () => {
        if(form.processing) return;

        abortEarly.value = false;
        await form.validate({all: true});
        nextTick(()=>{
            if(!canSubmitForm.value && !props.bypassRecaptcha){
                let element = getFirstInvalidInputElement({
                    className: 'field-state-dealer-app'
                });
                if(element){
                    element.scrollToAndFocus();
                }
            }else if((canSubmitForm.value || props.bypassRecaptcha) && !existingDealerOption.value){
                if(window.sentry){
                    window.sentry.setUser({
                        email: form.email_address,
                    })
                }
                form.transform((data)=>{
                    data.sale_on_other_countries = JSON.stringify(data.sale_on_other_countries);
                    data.customer_resales_types = JSON.stringify(data.customer_resales_types);
                    data.company_socials = JSON.stringify(data.company_socials);
                    data.additional_contacts = JSON.stringify(data.additional_contacts);
                    data.additional_shippings = JSON.stringify(data.additional_shippings);
                    data.shipping_address_same_mail_address = sameAsMailingAddress.value;
                    data.how_did_you_hear_about_rothco = JSON.stringify(data.how_did_you_hear_about_rothco);
                    data['g-recaptcha-response'] = captchaResponse.value;
                    data.conditionalSalesperson = data.conditional_salesperson;
                    data.rothco_dealer_no = null;
                    data.zip = null;

                    if(data.dealer_type == 'brick_mortar' && retailOption.value != 'add'){
                        data.retails_address_same_as = retailOption.value;
                    }
                    if(data.dealer_type != 'brick_mortar' || retailOption.value != 'add'){
                        data.retail_in_care_of = '';
                        data.retail_address1 = '';
                        data.retail_address2 = '';
                        data.retail_city = '';
                        data.retail_state = '';
                        data.retail_zip_code = '';
                        data.retail_country = '';
                    }
                    return {
                        ...data
                    };
                }).post(route('endpoints.dealerapplication.store'), {
                    onSuccess(){
                        if(window.sentry){
                            let replay = window.sentry.getReplay();
                            replay.stop();
                            window.sentry.setUser({
                                email: null
                            });
                        }
                    },
                    onError(errors){
                        // scroll to id errorMessage
                        let errorElement = document.getElementById('errorMessage');
                        if(errorElement){
                            errorElement.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                        }
                    },
                });
            }else if((canSubmitForm.value || props.bypassRecaptcha) && isLoggedIn.value){
                if(window.sentry){
                    window.sentry.setUser({
                        email: form.email_address,
                    })
                }
                form.transform((data)=>{
                    let payloadData: any = {};
                    payloadData.existing = existingDealerOption.value ?? false;
                    payloadData.rothco_dealer_no = existingDealerOption.value ? data.rothco_dealer_no : null;
                    payloadData.zip = data.zip;
                    payloadData['g-recaptcha-response'] = captchaResponse.value;
                    payloadData.terms_condition = data.terms_condition;
                    return {
                        ...payloadData
                    }
                }).post(route('endpoints.dealerapplication.store'), {
                    onSuccess(){
                        if(window.sentry){
                            let replay = window.sentry.getReplay();
                            replay.stop();
                            window.sentry.setUser({
                                email: null
                            });
                        }
                    },
                    onError(errors){
                        // scroll to id errorMessage
                        let errorElement = document.getElementById('errorMessage');
                        if(errorElement){
                            errorElement.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                        }
                    },
                });
            }else if(canSubmitForm.value || props.bypassRecaptcha){
                if(window.sentry){
                    window.sentry.setUser({
                        email: form.email_address,
                    })
                }
                form.transform((data)=>{
                    let payloadData: any = {};
                    payloadData.existing = existingDealerOption.value ?? false;
                    payloadData.email = data.email_address;
                    payloadData.password = data.password;
                    payloadData.password_confirmation = data.password_confirmation;
                    payloadData.rothco_dealer_no = existingDealerOption.value ? data.rothco_dealer_no : null;
                    payloadData.zip = data.zip;
                    payloadData['g-recaptcha-response'] = captchaResponse.value;
                    payloadData.terms_condition = data.terms_condition;
                    return {
                        ...payloadData
                    }
                }).post(route('endpoints.dealerapplication.store'), {
                    onSuccess(){
                        if(window.sentry){
                            let replay = window.sentry.getReplay();
                            replay.stop();
                            window.sentry.setUser({
                                email: null
                            });
                        }
                    },
                    onError(errors){
                        // scroll to id errorMessage
                        let errorElement = document.getElementById('errorMessage');
                        if(errorElement){
                            errorElement.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                        }
                    },
                });
            }
        });
    }

    let setFile = (e) => {
        form.resale_certificate = e.target.files[0];
    }

    let getFileName = (file) => {
        if(file){
            return file.name;
        }
        return '';
    }
    let resaleCeritificateFileInput = ref();
    let triggerResaleFileClick = () => {
        resaleCeritificateFileInput.value.click();
    }

    onMounted(()=>{
        if(window.sentry){
            let replay = window.sentry.getReplay();
            replay.start();
        }
    })

    watchDebounced(()=> form.email_address, (value)=>{
        if(value && value.length > 0){
            useFetch(route('dealer-application.init')).post({
                email: value,
            })
        }
    }, {debounce: 1000});
</script>
<style lang="scss" scoped>
.reseller-agreement {
    display: flex; 
    justify-content: end; 
    padding: 0 2rem;
    .links-and-input {
        display: flex; 
        flex-direction: row; 
        gap: 0 0.5rem;
    }
}
.dealer-app-footer {
    display: flex; 
    justify-content: end; 
    padding: 0.5rem 1.25rem;
}
</style>